import { DateBox } from "./DateBox";
import { SelectField } from "./ui";

export type DatePrecision = "day" | "month";
const MONTHS = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

/** "noviembre 2026" for a date of that month. */
export const monthText = (date: string) => `${MONTHS[Number(date.slice(5, 7)) - 1] ?? ""} ${date.slice(0, 4)}`;

/** Next 18 months as "YYYY-MM-01", starting with the current one (Mexico City). */
export function upcomingMonths(now = new Date()) {
  const key = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Mexico_City", year: "numeric", month: "2-digit" }).format(now);
  const [year, month] = key.split("-").map(Number) as [number, number];
  return Array.from({ length: 18 }, (_, i) => {
    const total = year * 12 + (month - 1) + i;
    return `${Math.floor(total / 12)}-${String((total % 12) + 1).padStart(2, "0")}-01`;
  });
}

/**
 * Trip date with an exact day, or only the month when the customer does not know the day yet.
 * With "Solo el mes" the value is the 1st of that month and the precision is "month".
 */
export function TripDateField({ label, name, value, precision, onChange }: {
  label: string;
  name: string;
  value: string;
  precision: DatePrecision;
  onChange: (date: string, precision: DatePrecision) => void;
}) {
  const months = upcomingMonths();
  const monthValue = value ? `${value.slice(0, 7)}-01` : "";
  return (
    <div className="trip-date">
      <div className="trip-date__mode" role="group" aria-label={`${label}: precisión`}>
        <button type="button" className="funnel-chip" aria-pressed={precision === "day"} onClick={() => onChange(precision === "day" ? value : "", "day")}>
          Día exacto
        </button>
        <button type="button" className="funnel-chip" aria-pressed={precision === "month"} onClick={() => onChange(value ? monthValue : "", "month")}>
          Solo el mes
        </button>
      </div>
      {precision === "day" ? (
        <DateBox label={label} name={name} value={value} onChange={(date) => onChange(date, "day")} />
      ) : (
        <SelectField label={`${label} (mes)`} value={monthValue} onChange={(e) => onChange(e.target.value, "month")}>
          <option value="">Elegir mes</option>
          {[...new Set([...(monthValue && !months.includes(monthValue) ? [monthValue] : []), ...months])].map((month) => (
            <option key={month} value={month}>{monthText(month)}</option>
          ))}
        </SelectField>
      )}
    </div>
  );
}
